var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5003 1.16666C34.0003 1.16666 43.3337 10.5021 43.3337 22C43.3337 33.4979 34.0003 42.8333 22.5003 42.8333C11.0003 42.8333 1.66699 33.4979 1.66699 22C1.66699 10.5021 11.0003 1.16666 22.5003 1.16666Z",
    stroke: "#C83532",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 9.50003C24.0346 9.50003 25.2777 10.7445 25.2777 12.2778C25.2777 13.8111 24.0346 15.0556 22.4999 15.0556C20.9653 15.0556 19.7222 13.8111 19.7222 12.2778C19.7222 10.7445 20.9653 9.50003 22.4999 9.50003Z",
    stroke: "#C83532",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2778 23.3889C25.2778 22.6521 24.986 21.9458 24.4653 21.425C23.9444 20.9035 23.2361 20.6111 22.5 20.6111C20.9653 20.6111 19.7222 21.8549 19.7222 23.3889V31.7222C19.7222 32.4591 20.0139 33.1653 20.5348 33.6861C21.0556 34.2076 21.7639 34.4999 22.5 34.4999C24.0347 34.4999 25.2778 33.2563 25.2778 31.7222V23.3889Z",
    stroke: "#C83532",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.ae8c90eb.svg";
export { ForwardRef as ReactComponent };